<mat-card class="betriebskontakt-card" [class.compact]="config.compact">
    <mat-card-header>
        <div class="mat-card-header-text" style="margin-left: 0px; margin-right: 0px"></div>
        <div class="card-header-content">
            <!-- Links: Betriebsname mit Favorit -->
            <div class="card-title-section">
                <div class="title-row">
                    <mat-icon *ngIf="config.showFavorit && kontakt.favorit === 1" class="favorit-icon">star</mat-icon>
                    <mat-card-title>{{ kontakt.bezeichnung_final }}</mat-card-title>
                </div>
                <mat-card-subtitle *ngIf="kontakt.zusatz_final" class="zusatz-subtitle">{{
                    kontakt.zusatz_final
                }}</mat-card-subtitle>
            </div>

            <!-- Rechts: Badge und Button -->
            <div class="card-actions" *ngIf="config.showActions">
                <span
                    *ngIf="config.showBadge"
                    class="betriebsart-badge"
                    [style.background-color]="getBetriebsartBadgeColor(kontakt.betriebsart_id)"
                >
                    {{ getBetriebsartBadgeText(kontakt.betriebsart_id) }}
                </span>

                <!-- Entfernen-Symbol für selectedMode -->
                <button
                    type="button"
                    *ngIf="config.selectedMode"
                    mat-icon-button
                    (click)="onEntfernen()"
                    class="remove-button"
                    matTooltip="Kontakt entfernen"
                >
                    <mat-icon>close</mat-icon>
                </button>

                <!-- Direkter "Hinzufügen"-Button (nur sichtbar wenn Kontakt nicht bereits vorhanden ist) -->
                <button
                    type="button"
                    *ngIf="
                        (showHinzufuegen !== undefined ? showHinzufuegen : config.showHinzufuegen) &&
                        !config.istKontaktBereitsVorhanden
                    "
                    mat-icon-button
                    (click)="onHinzufuegen()"
                    class="hinzufuegen-button"
                    matTooltip="Zu Kontakten hinzufügen"
                    [disabled]="config.ladeHinzufuegen"
                    style="color: #4caf50"
                >
                    <mat-spinner *ngIf="config.ladeHinzufuegen" diameter="16"></mat-spinner>
                    <mat-icon *ngIf="!config.ladeHinzufuegen">add</mat-icon>
                </button>

                <!-- Volles Menü für bearbeitbare Cards -->
                <button
                    type="button"
                    *ngIf="config.showMenu && !config.selectedMode"
                    mat-icon-button
                    [matMenuTriggerFor]="kontakteMenu"
                    class="menu-button"
                >
                    <mat-icon>more_vert</mat-icon>
                </button>
            </div>
        </div>
    </mat-card-header>

    <!-- Visueller Trenner zwischen Header und Body -->
    <div class="card-divider"></div>

    <mat-card-content>
        <div class="kontakt-info">
            <div class="info-row" *ngIf="kontakt.vvvo">
                <mat-icon>business</mat-icon>
                <span>VVVO: {{ kontakt.vvvo }}</span>
            </div>
            <div class="info-row" *ngIf="getVollAdresse(kontakt)">
                <mat-icon>location_on</mat-icon>
                <span>{{ getVollAdresse(kontakt) }}</span>
            </div>
            <div class="info-row" *ngIf="kontakt.telefon_1">
                <mat-icon>phone</mat-icon>
                <a href="tel:{{ kontakt.telefon_1 }}" class="contact-link" (click)="onCallPhone(kontakt.telefon_1!)">
                    Tel: {{ kontakt.telefon_1 }}
                </a>
            </div>
            <div class="info-row" *ngIf="kontakt.telefon_2">
                <mat-icon>phone</mat-icon>
                <a href="tel:{{ kontakt.telefon_2 }}" class="contact-link" (click)="onCallPhone(kontakt.telefon_2!)">
                    Tel 2: {{ kontakt.telefon_2 }}
                </a>
            </div>
            <div class="info-row" *ngIf="kontakt.mobil_1">
                <mat-icon>smartphone</mat-icon>
                <a href="tel:{{ kontakt.mobil_1 }}" class="contact-link" (click)="onCallPhone(kontakt.mobil_1!)">
                    Mobil: {{ kontakt.mobil_1 }}
                </a>
            </div>
            <div class="info-row" *ngIf="kontakt.mobil_2">
                <mat-icon>smartphone</mat-icon>
                <a href="tel:{{ kontakt.mobil_2 }}" class="contact-link" (click)="onCallPhone(kontakt.mobil_2!)">
                    Mobil 2: {{ kontakt.mobil_2 }}
                </a>
            </div>
            <div class="info-row" *ngIf="kontakt.email">
                <mat-icon>email</mat-icon>
                <a href="mailto:{{ kontakt.email }}" class="contact-link" (click)="onSendMail()">
                    {{ kontakt.email }}
                </a>
            </div>
        </div>
    </mat-card-content>

    <!-- Menü für Aktionen -->
    <mat-menu #kontakteMenu>
        <button mat-menu-item (click)="onBearbeiten()" [disabled]="config.canEdit === false">
            <mat-icon>edit</mat-icon>
            <span>Bearbeiten</span>
        </button>
        <button mat-menu-item (click)="onToggleFavorit()">
            <mat-icon>{{ kontakt.favorit === 1 ? "star_border" : "star" }}</mat-icon>
            <span>{{ kontakt.favorit === 1 ? "Favorit entfernen" : "Als Favorit markieren" }}</span>
        </button>
        <button
            *ngIf="config.showHinzufuegen && !config.istKontaktBereitsVorhanden"
            mat-menu-item
            (click)="onHinzufuegen()"
            [disabled]="config.ladeHinzufuegen"
            style="color: #4caf50"
        >
            <mat-spinner *ngIf="config.ladeHinzufuegen" diameter="16"></mat-spinner>
            <mat-icon *ngIf="!config.ladeHinzufuegen">add</mat-icon>
            <span>{{ config.ladeHinzufuegen ? "Hinzufügen..." : "Zu Kontakten hinzufügen" }}</span>
        </button>
        <button mat-menu-item (click)="onEntfernen()" style="color: #f44336">
            <mat-icon>delete</mat-icon>
            <span>Kontakt entfernen</span>
        </button>
    </mat-menu>
</mat-card>
